import { FC, useEffect, useRef } from "react";

import authService from "@http/services/auth.service";
import { useRedirectAfterLogin } from "@hooks/useRedirectAfterLogin";
import { useRouter } from "next/router";
import { getTenantConfig } from "src/utils/tenant";

const Home: FC = () => {
  const router = useRouter();
  const [redirect, setRedirect] = useRedirectAfterLogin();
  const redirectingRef = useRef(false);

  useEffect(() => {
    if (!router.isReady) {
      return;
    }

    const desiredRedirect = (router.query.redirect as string) || redirect;
    setRedirect((router.query.redirect as string) || undefined);

    let mounted = true;
    const bootstrapAuth = async () => {
      try {
        // fetchUser uses existing cookies and tries token refresh on 401 before failing
        const user = await authService.fetchUser();
        if (!mounted) {
          return;
        }

        if (user) {
          localStorage.removeItem("redirect_after_login");
          router.replace(desiredRedirect || process.env.NEXT_PUBLIC_DASHBOARD_URL || "/dashboard");
          return;
        }
      } catch {
        // No valid user after fetchUser (and optional refresh) — redirect to login
      }

      if (mounted && !redirectingRef.current) {
        redirectingRef.current = true;
        window.location.href = getTenantConfig().keycloakLoginUrl;
      }
    };

    bootstrapAuth();

    return () => {
      mounted = false;
    };
  }, [router, redirect, setRedirect]);

  return null;
};

export default Home;
